import { AddressForm } from "./dto/AddressDTO";

export const InitialAddress: AddressForm = {
    country: "",
    city: "",
    address: "",
};
